import { render, staticRenderFns } from "./studyManage.vue?vue&type=template&id=3d243d16&"
import script from "./studyManage.vue?vue&type=script&lang=js&"
export * from "./studyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports